import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Mtrwd } from '../entity/Mtrwd-angular';




export interface MtrwdData {
    COMPANY: string ;
    CREATOR: string;
    USR_GROUP: string ;
    CREATE_DATE: string;
    MODIFIER: string;
    MODI_DATE: string;
    FLAG: number;

    WD001: string;            // 建檔時間 20 **
    WD002: string;            // 工作日期 8 **
    WD003: string;            // 內文 0 **
    WD004: string;            // 主旨 100
    WD005: string;            // 提醒日期 8
    WD006: string;            // 提醒時間 6
    WD010: string;            // 提醒碼 1
    WD011: string;            // 狀態 1 ** [DEF:"1"] {{1.未開始 2.進行中   3.等待某人 4.延期 9.已完成}}
    WD012: string;            // 優先順序 1 ** [DEF:"5"] 1..9
    WD013: number;            // 進度 3 [DEF:0]   1..100
    WD014: string;            // 工作者 10 ** default UserID
    WD015: string;            // 大分類 10
    WD016: string;            // 中分類 10
    WD017: string;            // 結案碼 1 ** [DEF:"N"]
    WD018: string;            // 星期 2 **
    WD019: number;            // 金額 8 [DEF:0]
    WD020: number;            // 預估時數 8.2 **
    WD021: string;            // 客戶代號 10 ** 使用者
    WD022: string;            // 私人的 1 ** [DEF:"N"]  951203 add
    WD023: string;            // 週期 1 [DEF:"N"] {{D:每日 W:每週 M:每月}}
    WD024: string;            // 小分類 20
    WD025: number;            // 計費時數 8.2 **
    WD026: string;            // RTF內文 0
    WD027: string;            // 星號 1 [DEF:"N"]
    WD028: string;            // 來源單號 60
    WD029: string;            // 格式 1 [DEF:"T"]  T:text H:html M:markdown
    WD030: string;            // 雲端硬碟URL 500
    WD031: string;            // 來源單號 20
    WD032: string;            // text內文 0

}


export const MtrWd011List =  [ { id:"1" , name:"未開始" },{ id:"2" , name:"進行中" },{ id:"3" , name:"等待某人" },{ id:"4" , name:"延期" },{ id:"9" , name:"已完成" } ] ; // 狀態
export const MtrWd023List =  [ { id:"D" , name:"每日" },{ id:"W" , name:"每週" },{ id:"M" , name:"每月" } ] ; // 週期

@Injectable({
  providedIn: 'root'
})
export class MtrwdServicePkg extends JkEntityV2 {
  MtrWd011List= MtrWd011List;
  MtrWd023List= MtrWd023List;


  constructor() {
    super();
    this.linkMasterFields = '' ;
    this.defaultItem = new Mtrwd();
    this.entityType.type = EntityType.master;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
        WD001 : '建檔時間' , WD002 : '工作日期' , WD003 : '內文' , WD004 : '主旨' , WD005 : '提醒日期' , WD006 : '提醒時間' , WD010 : '提醒碼' , WD011 : '狀態' , WD012 : '優先順序' , WD013 : '進度' , WD014 : '工作者' , WD015 : '大分類' , WD016 : '中分類' , WD017 : '結案碼' , WD018 : '星期' , WD019 : '金額' , WD020 : '預估時數' , WD021 : '客戶代號' , WD022 : '私人的' , WD023 : '週期' , WD024 : '小分類' , WD025 : '計費時數' , WD026 : 'RTF內文' , WD027 : '星號' , WD028 : '來源單號' , WD029 : '格式' , WD030 : '雲端硬碟URL' , WD031 : '來源單號' , WD032 : 'text內文'  };

    this.fieldNames = 'WD001,WD002,WD003,WD004,WD005,WD006,WD010,WD011,WD012,WD013,WD014,WD015,WD016,WD017,WD018,WD019,WD020,WD021,WD022,WD023,WD024,WD025,WD026,WD027,WD028,WD029,WD030,WD031,WD032' ;
    this.fieldLengths = {WD001 : 20 ,WD002 : 8 ,WD003 : 0 ,WD004 : 100 ,WD005 : 8 ,WD006 : 6 ,WD010 : 1 ,WD011 : 1 ,WD012 : 1 ,WD013 : 3 ,WD014 : 10 ,WD015 : 10 ,WD016 : 10 ,WD017 : 1 ,WD018 : 2 ,WD019 : 8 ,WD020 : 8.2 ,WD021 : 10 ,WD022 : 1 ,WD023 : 1 ,WD024 : 20 ,WD025 : 8.2 ,WD026 : 0 ,WD027 : 1 ,WD028 : 60 ,WD029 : 1 ,WD030 : 500 ,WD031 : 20 ,WD032 : 0 } ;
    this.columnDefs = [
      { field: "WD027", headerName: "星號",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
      { field: "WD002", headerName: "工作日期",headerTooltip: "",width:120,cellDataType: "text", valueFormatter: dateFormatter,  },
      { field: "WD018", headerName: "星期",headerTooltip: "",width:86,cellDataType: "text", },
      { field: "WD004", headerName: "主旨",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "WD003", headerName: "內文",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "WD026", headerName: "RTF內文",headerTooltip: "",width:250,cellDataType: "text", },
      //{ field: "WD015", headerName: "大分類",headerTooltip: "",width:150,cellDataType: "text", cellRenderer: AgComboBoxEditor,cellRendererParams:{list:this.MtrWd015List}, },
      //{ field: "WD016", headerName: "中分類",headerTooltip: "",width:150,cellDataType: "text", cellRenderer: AgComboBoxEditor,cellRendererParams:{list:this.MtrWd016List}, },
      //{ field: "WD024", headerName: "小分類",headerTooltip: "",width:230,cellDataType: "text", cellRenderer: AgComboBoxEditor,cellRendererParams:{list:this.MtrWd024List}, },
      { field: "WD014", headerName: "工作者",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WD021", headerName: "客戶代號",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WD025", headerName: "計費時數",headerTooltip: "",width:136,cellDataType: "number", cellStyle: { 'text-align': 'right' },  },
      { field: "WD011", headerName: "狀態",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgComboBoxEditor,cellRendererParams:{list:this.MtrWd011List}, },
      { field: "WD017", headerName: "結案碼",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
      { field: "WD010", headerName: "提醒碼",headerTooltip: "",width:80,cellDataType: "text", },
      { field: "WD005", headerName: "提醒日期",headerTooltip: "",width:120,cellDataType: "text", valueFormatter: dateFormatter,  },
      { field: "WD006", headerName: "提醒時間",headerTooltip: "",width:118,cellDataType: "text", },
      { field: "WD012", headerName: "優先順序",headerTooltip: "",width:80,cellDataType: "text", },
      { field: "WD013", headerName: "進度",headerTooltip: "",width:94,cellDataType: "number", cellStyle: { 'text-align': 'right' },  },
      { field: "WD020", headerName: "預估時數",headerTooltip: "",width:136,cellDataType: "number", cellStyle: { 'text-align': 'right' },  },
      { field: "WD022", headerName: "私人的",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgCheckBoxEditor,  },
      { field: "WD023", headerName: "週期",headerTooltip: "",width:80,cellDataType: "text", cellRenderer: AgComboBoxEditor,cellRendererParams:{list:this.MtrWd023List}, },
      { field: "WD019", headerName: "金額",headerTooltip: "",width:134,cellDataType: "number", cellStyle: { 'text-align': 'right' },  },
      { field: "WD028", headerName: "來源單號",headerTooltip: "",width:250,cellDataType: "text", },
      { field: "WD001", headerName: "建檔時間",headerTooltip: "",width:230,cellDataType: "text", },
      { field: "WD029", headerName: "格式",headerTooltip: "",width:80,cellDataType: "text", },
      { field: "WD030", headerName: "雲端硬碟URL",headerTooltip: "",width:250,cellDataType: "text", cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,  },
      { field: "WD031", headerName: "來源單號",headerTooltip: "",width:230,cellDataType: "text", },
      { field: "WD032", headerName: "text內文",headerTooltip: "",width:250,cellDataType: "text", },
    ];
    this.columnDefsVir = [
      { field: "WD014C", headerName: "姓名",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WD015C", headerName: "名稱",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WD016C", headerName: "名稱",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WD021C", headerName: "客戶簡稱",headerTooltip: "",width:150,cellDataType: "text", },
      { field: "WD024C", headerName: "名稱",headerTooltip: "",width:150,cellDataType: "text", },
    ];
    this.tableName = 'MTRWD' ;
    this.isSys =false;
    this.sqlSelect = `SELECT TOP 1000 isNull(WL.CNT,0) AS CNT,A.MG003 AS WD015C,B.MG003 AS WD016C,C.MG003 AS WD024C,
MV002 AS WD014C,COPMA.MA002 AS WD021C,MTRWD.*
FROM MTRWD
LEFT JOIN COPMA ON MA001=WD021
LEFT JOIN CMSMV ON MV001=WD014
LEFT JOIN JCKMG AS A ON A.MG001='MTRWD' AND A.MG002=WD015
LEFT JOIN JCKMG AS B ON B.MG001='MTRWD2' AND B.MG002=WD016
LEFT JOIN JCKMG AS C ON C.MG001='MTRWD3' AND C.MG002=WD024
LEFT JOIN (SELECT count(*) as CNT,WL001 FROM MTRWL GROUP BY WL001) AS WL  ON WL.WL001=WD001 ` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = `ORDER BY WD012,WD002 DESC` ;
    this.keyFields = ['WD001'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['WD001','WD002','WD021'];
    this.seqField = '' ;
    this.seqFieldLength = 4 ;
  }
  override async validateItem(item: Mtrwd): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem:Mtrwd): Promise<Mtrwd> {
  await  super.newRecord(newItem);
    return newItem;
  }




}

